import React from 'react';
import PhoneInput from 'react-phone-number-input/input';

import InputContainer from '../InputContainer/input-container';

export default class TextInput extends React.PureComponent {
	render() {
		return (
			<InputContainer
				validationError={this.props.validationError}
				id={this.props.id}
				label={this.props.label}
				helpText={this.props.optional ? 'Optional' : ''}
				width={this.props.width}
				labelAfterInput={this.props.labelAfterInput}
				body={
					<PhoneInput
						disabled={this.props.disabled}
						name={this.props.name}
						country="US"
						type={this.props.type ? this.props.type : 'tel'}
						id={this.props.id}
						value={this.props.value || ''}
						required={!this.props.optional}
						onChange={this.props.onChange}
						placeholder={this.props.placeholder}
						className="form-control"
					/>
				}
			/>
		);
	}
}
